import { PdFormRow } from "./pd-form-row/PdFormRow.js";
//#region src/pd-form-row/pd-form-row.ts
var tag = "pd-form-row";
if (!customElements.get(tag)) customElements.define(tag, PdFormRow);
//#endregion
export { PdFormRow };
